import React, { useEffect, useState } from "react";
import { TouchableOpacity, View } from "react-native";
import { changeParentSelected, setSelectedFilters } from "appRedux/reducers/filterSlice";
import { fp, spH, spV } from "utils/normalise";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalSearchParams, useLocalSearchParams, useSegments } from "expo-router";
import { Helmet } from "react-helmet";


import ImageView from "../../image";
import { Images } from "assets";
import VText from "components/VText";
import { categoryArr } from "utils/Constants";
import { memo } from "react";
import { removeObjectWithId } from "utils/common";

const FilterChips = ({ containerstyle = {}, listviewContainer = {} }) => {
    const [selectedData, setSelectedData] = useState([]);
    const selectedFilters = useSelector((state) => state.FilterReducer.selectedFilters);
    const parentSelected = useSelector((state) => state.FilterReducer.parentSelected);

    const local = useGlobalSearchParams();
    const segments  = useSegments()
    const gender = local?.gender || 'female';

    const isCategory = segments?.includes('shop') && Object.keys(categoryArr)?.includes(segments?.[1]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedFilters || parentSelected) {
            let temp = [];
            let obj = {
                ...selectedFilters,
                1: [...(selectedFilters?.[1] || []), ...(isCategory ? [] : parentSelected || [])],
            };
            let keys = Object.keys(obj);
            keys.forEach((key) => {
                if (Array.isArray(obj[key])) {
                    temp.push(obj[key]);
                }
            });
            temp = temp.flat();
            setSelectedData(temp);
        }
    }, [selectedFilters, parentSelected, isCategory]);

    const handleRemoveFilter = (item) => {
        let newSelectedFilters = { ...selectedFilters };
        removeObjectWithId(newSelectedFilters, item?.id);
        dispatch(setSelectedFilters(newSelectedFilters));
        if (item?.isSubCategory && item?.categoryID == 1) {
            dispatch(
                changeParentSelected({
                    ...item,
                })
            );
        }
        // dispatch(changeParentSelected({ isAdd: false, id: item?.id, categoryID: 1 }));
    };

    return (
        <>
        <Helmet>
            <title>
                {`${local?.title || segments?.[1]}`?.replaceAll("-", " ")}
                {selectedData?.length > 0 ? `${selectedData?.map((o,idx)=>` | ${o?.title} `)}`?.replaceAll(',','') : ""} 
                {gender && gender !== "both" ? ` | ${gender.replace("female", "Women").replace("male", "Men")}`.replaceAll(",", "") : ""} 
                {' | Vetirapp'}
            </title>
        </Helmet>
        <View style={[{}, containerstyle]}>
            {selectedData && selectedData.length > 0 && (
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        flexWrap: "wrap",
                    }}
                >
                    {[Array.isArray(selectedData) ? selectedData : []]?.flat().map((item, idx) => (
                        <View
                            style={{
                                borderWidth: 1,
                                borderColor: "#cbcbcb",
                                marginRight: 8,
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: spV(12),
                                borderRadius: 2,
                                paddingHorizontal: spH(12),
                            }}
                            key={idx}
                        >
                            <VText
                                style={{
                                    fontSize: fp(14),
                                    fontWeight: "350",
                                    lineHeight: "140%",
                                    color: "#212427",
                                    paddingVertical: spV(8),
                                    paddingRight: spH(12),
                                }}
                                text={item?.title}
                            />
                            <TouchableOpacity
                                activeOpacity={0.8}
                                style={{
                                    paddingVertical: 4,
                                }}
                                onPress={() => {
                                    handleRemoveFilter(item);
                                }}
                            >
                                <ImageView source={Images.crossIcon} style={{ height: 12, width: 12 }} />
                            </TouchableOpacity>
                        </View>
                    ))}
                </View>
            )}
        </View>
        </>
    );
};

export default memo(FilterChips);
